import type { SearchFormValues } from '../schema';

export const formatDateToApi = (value?: string | null) => {
  if (!value) return '';
  return value.replace(/-/g, '').slice(0, 8);
};

export const buildSoChiTietCongNoSearchPayload = (
  data: SearchFormValues,
  accountUuid: string,
  customerUuid: string
) => {
  const payload: MuaHangRecord = {
    ...data,
    ngay_ct1: data.ngay_ct1,
    ngay_ct2: data.ngay_ct2,
    tk: accountUuid,
    ma_kh: customerUuid
  };

  if (typeof data.ct_vt === 'boolean') {
    if (data.ct_vt) {
      payload.ct_vt = 1;
    } else {
      delete payload.ct_vt;
    }
  }

  if (typeof data.so_du === 'boolean') {
    if (data.so_du) {
      payload.so_du = 1;
    } else {
      delete payload.so_du;
    }
  }

  return payload;
};

export { getColumns } from './getColumns';
